import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Testimonials.css';

const AdminTestimonials = () => {
  const names = ['Maxwell Mutunga','Benjamin Wambua','Francis Muli','Tom Nguza','Abraham Kivondo'];
  return (
    <div className="testimonials-page">
      <h1>Testimonials</h1>
      <p>Manage client testimonials.</p>
      <button className="add-btn"><FaPlus /> Add Testimonial</button>
      <table className="testimonials-table">
        <thead><tr><th>#</th><th>Client</th><th>Rating</th><th>Date</th><th>Actions</th></tr></thead>
        <tbody>{names.map((name,i)=>(<tr key={i}><td>{i+1}</td><td>{name}</td><td className="stars">★★★★★</td><td>April 2026</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminTestimonials;
